import React from 'react';
import type { IntakeValidationErrorItem } from './intakeValidationErrorItems';

// `text-left` overrides the browser default `text-align: center` on <button>,
// which otherwise centers each wrapped line of a long validation message.
const FIELD_LINK_CLASS =
  'text-left underline underline-offset-2 hover:text-red-900 focus:outline-none focus:ring-1 focus:ring-red-500 rounded';

interface IntakeValidationErrorListProps {
  title: string;
  items: IntakeValidationErrorItem[];
  ariaLabel: string;
  className?: string;
}

/**
 * Clickable comma-separated validation list shared by pre-push gates and
 * post-push backend field errors on the intake workflow.
 */
export const IntakeValidationErrorList: React.FC<
  IntakeValidationErrorListProps
> = ({ title, items, ariaLabel, className }) => {
  if (items.length === 0) return null;

  return (
    <div className={className}>
      {title ? <p className='font-medium'>{title}</p> : null}
      <p>
        <span role='list' aria-label={ariaLabel}>
          {items.map((item, index) => (
            <span key={item.id} role='listitem'>
              {index > 0 ? ', ' : null}
              {item.onClick ? (
                <>
                  <button
                    type='button'
                    onClick={item.onClick}
                    className={FIELD_LINK_CLASS}
                  >
                    {item.label}
                  </button>
                  {item.detail ? `: ${item.detail}` : null}
                </>
              ) : item.detail ? (
                <>
                  {item.label}: {item.detail}
                </>
              ) : (
                item.label
              )}
            </span>
          ))}
        </span>
      </p>
    </div>
  );
};
